/* Zaruba theme — global interactivity. Vanilla JS, no build step. */
(function () {
  'use strict';

  var cfg = window.ZarubaTheme || { routes: {}, strings: {}, moneyFormat: '${{amount}}' };

  /* Storefront text comes from the locale files (layout/theme.liquid prints it
     into ZarubaTheme.strings), so JS-rendered copy translates with the rest of
     the store. Values arrive with [token] placeholders for the dynamic parts.
     Liquid's t filter HTML-escapes its output (an apostrophe arrives as &#39;),
     so each string is decoded once here — before the tokens are filled, so a
     shopper's own text is never decoded — and every caller then treats the
     result as plain text (textContent, or escapeHtml for innerHTML). */
  var entityDecoder = document.createElement('textarea');
  function t(key, vars) {
    entityDecoder.innerHTML = (cfg.strings && cfg.strings[key]) || key;
    var str = entityDecoder.value;
    Object.keys(vars || {}).forEach(function (k) { str = str.split('[' + k + ']').join(vars[k]); });
    return str;
  }

  /* ---------------------------------------------------------------- */
  /* Utilities                                                         */
  /* ---------------------------------------------------------------- */
  /* Mirrors Liquid's `money_without_trailing_zeros`, which the templates use —
     otherwise a JS re-render would flip "$1,799" to "$1,799.00" on load. */
  function formatMoney(cents) {
    var format = cfg.moneyFormat || '${{amount}}';
    var whole = cents % 100 === 0;
    var value = whole ? String(cents / 100) : (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    return format
      .replace('{{amount}}', addCommas(value))
      .replace('{{amount_no_decimals}}', addCommas(Math.round(cents / 100).toString()))
      .replace('{{amount_with_comma_separator}}', addCommasEU(withComma))
      .replace('{{amount_no_decimals_with_comma_separator}}', addCommasEU(String(Math.round(cents / 100))));
  }
  function addCommas(v) {
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function addCommasEU(v) {
    var parts = v.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',');
  }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------------------------------------------------------------- */
  /* Toast                                                              */
  /* ---------------------------------------------------------------- */
  var toastTimer = null;
  function showToast(message) {
    var el = qs('#toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 1800);
  }
  window.ZarubaToast = showToast;

  /* ---------------------------------------------------------------- */
  /* Top-nav hover menus                                               */
  /* ---------------------------------------------------------------- */
  /* Opening on hover and on keyboard focus is pure CSS (:hover /
     :focus-within). This adds the two things CSS can't do: keep a panel from
     running off the right edge of the window, and give touch — which has no
     hover at all — a first-tap-opens, second-tap-follows parent link. */
  function initNavMenus() {
    var nav = qs('[data-nav]');
    if (!nav) return;
    var items = qsa('[data-nav-item]', nav);
    if (!items.length) return;
    var touch = window.matchMedia('(hover: none)').matches;
    var open = null;

    function place(item) {
      var panel = qs('[data-nav-menu]', item);
      if (!panel) return;
      panel.classList.remove('flip');
      if (panel.getBoundingClientRect().right > window.innerWidth - 12) panel.classList.add('flip');
    }
    function close() {
      if (!open) return;
      open.classList.remove('open');
      open = null;
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { place(item); });
      item.addEventListener('focusin', function () { place(item); });
      if (!touch) return;
      var trigger = qs('[data-nav-trigger]', item);
      if (!trigger) return;
      var panel = qs('[data-nav-menu]', item);
      trigger.addEventListener('click', function (e) {
        if (open === item) return;
        /* Phones hide the panels (the hamburger drawer covers them), so the
           first tap has nothing to open and must follow the link. */
        if (!panel || getComputedStyle(panel).display === 'none') return;
        e.preventDefault();
        close();
        place(item);
        item.classList.add('open');
        open = item;
      });
    });

    if (touch) {
      document.addEventListener('click', function (e) {
        if (open && !open.contains(e.target)) close();
      });
    }
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      close();
      if (document.activeElement && nav.contains(document.activeElement)) document.activeElement.blur();
    });
  }
  initNavMenus();

  /* ---------------------------------------------------------------- */
  /* Generic overlay drawers (menu / search / compare modal)           */
  /* data-drawer="name" on the panel root (scrim + panel share it)     */
  /* [data-open="name"] / [data-close="name"] on triggers               */
  /* ---------------------------------------------------------------- */
  var lockers = 0;
  function lockScroll() {
    lockers++;
    document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll() {
    lockers = Math.max(0, lockers - 1);
    if (lockers === 0) document.documentElement.style.overflow = '';
  }
  /* Each drawer's panel is a modal dialog ([role="dialog"], tabindex="-1").
     Opening moves focus into it and closing hands focus back to whatever
     opened it; while it's open, Tab cycles inside it rather than wandering
     into the page underneath. Triggers carry aria-expanded to match. */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';
  var returnFocus = {};
  function drawerPanel(name) { return qs('[data-drawer="' + name + '"] [role="dialog"]'); }
  function setExpanded(name, open) {
    qsa('[data-open="' + name + '"]').forEach(function (el) { el.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  function openDrawer(name) {
    var roots = qsa('[data-drawer="' + name + '"]');
    if (!roots.length || roots.every(function (el) { return !el.hidden; })) return;
    returnFocus[name] = document.activeElement;
    roots.forEach(function (el) { el.hidden = false; });
    lockScroll();
    setExpanded(name, true);
    document.dispatchEvent(new CustomEvent('zaruba:drawer:open', { detail: { name: name } }));
    var panel = drawerPanel(name);
    if (panel && !panel.contains(document.activeElement)) panel.focus();
  }
  /* Only unlock for a drawer that was actually open: the Escape handler below
     closes all of them every time, so an unconditional unlockScroll() would
     decrement the counter for drawers that were already shut and let the page
     scroll behind one that is still open. */
  function closeDrawer(name) {
    var closed = false;
    qsa('[data-drawer="' + name + '"]').forEach(function (el) {
      if (el.hidden) return;
      el.hidden = true;
      closed = true;
    });
    if (!closed) return;
    unlockScroll();
    setExpanded(name, false);
    var back = returnFocus[name];
    returnFocus[name] = null;
    if (back && back !== document.body && document.contains(back) && back.focus) back.focus();
  }
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-open]');
    if (openTrigger) { e.preventDefault(); openDrawer(openTrigger.getAttribute('data-open')); }
    var closeTrigger = e.target.closest('[data-close]');
    if (closeTrigger) { e.preventDefault(); closeDrawer(closeTrigger.getAttribute('data-close')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      ['menu', 'search', 'compare-modal', 'cart'].forEach(closeDrawer);
      return;
    }
    if (e.key !== 'Tab') return;
    var panels = qsa('[data-drawer]:not([hidden]) [role="dialog"]');
    var panel = panels[panels.length - 1];
    if (!panel) return;
    var items = qsa(FOCUSABLE, panel).filter(function (el) { return el.getClientRects().length > 0; });
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!panel.contains(active)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && (active === first || active === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });
  window.ZarubaDrawers = { open: openDrawer, close: closeDrawer };

  /* Coming back from /discount/<code> applied in the drawer: reopen it where
     the shopper left off, then drop the marker so the URL stays clean. */
  try {
    var drawerParams = new URLSearchParams(window.location.search);
    if (drawerParams.get('cart') === 'open') {
      openDrawer('cart');
      drawerParams.delete('cart');
      var drawerQuery = drawerParams.toString();
      if (window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname + (drawerQuery ? '?' + drawerQuery : '') + window.location.hash);
      }
    }
  } catch (e) {}

  /* ---------------------------------------------------------------- */
  /* Cart AJAX                                                          */
  /* ---------------------------------------------------------------- */
  var CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function refreshCartSections(sections) {
    if (!sections) return;
    var drawerHtml = sections['cart-drawer'];
    if (drawerHtml) {
      var tmp = document.createElement('div');
      tmp.innerHTML = drawerHtml;
      var next = tmp.querySelector('[data-cart-drawer-root]');
      var cur = qs('[data-cart-drawer-root]');
      if (next && cur) {
        /* Swapping the panel out drops whatever had focus inside it (a qty
           button, say) — keep keyboard users in the drawer, not at the top of
           the page. */
        var hadFocus = cur.contains(document.activeElement);
        cur.replaceWith(next);
        if (hadFocus) next.focus();
      }
    }
    var bubbleHtml = sections['cart-icon-bubble'];
    if (bubbleHtml) {
      qsa('[data-cart-icon-bubble]').forEach(function (el) {
        var tmp = document.createElement('div');
        tmp.innerHTML = bubbleHtml;
        var next = tmp.querySelector('[data-cart-icon-bubble]');
        if (next) el.replaceWith(next);
      });
    }
  }

  function cartFetch(url, body) {
    body.sections = CART_SECTIONS;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* Shopify's documented hand-off to checkout: POST the cart with a
     "checkout" field. routes.cart_url carries the shopper's locale/market
     prefix, which a hard-coded /checkout link would drop. */
  function goToCheckout() {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = cfg.routes.cart;
    var field = document.createElement('input');
    field.type = 'hidden';
    field.name = 'checkout';
    form.appendChild(field);
    document.body.appendChild(form);
    form.submit();
  }

  function addItemsToCart(items, opts) {
    opts = opts || {};
    return cartFetch(cfg.routes.cartAdd + '.js', { items: items })
      .then(function (res) {
        if (res.status) throw res;
        /* "Buy now" skips the drawer for the same checkout hand-off the
           drawer's own button makes, so anything already in the cart comes too. */
        if (opts.checkout) {
          goToCheckout();
          return res;
        }
        refreshCartSections(res.sections);
        showToast(t('itemAdded', { title: opts.label || t('item') }));
        var cartType = document.body.getAttribute('data-cart-type') || 'drawer';
        if (cartType === 'drawer') openDrawer('cart');
        else window.location.href = cfg.routes.cart;
        document.dispatchEvent(new CustomEvent('zaruba:cart:updated'));
        return res;
      })
      .catch(function (err) {
        showToast((err && err.description) || t('addError'));
        throw err;
      });
  }

  function addToCart(form) {
    var fd = new FormData(form);
    var items = [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }];
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    return addItemsToCart(items, { label: form.getAttribute('data-product-title'), checkout: form.hasAttribute('data-cart-add-checkout') })
      .catch(function () {})
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function changeLine(key, quantity) {
    return cartFetch(cfg.routes.cartChange + '.js', { id: key, quantity: quantity })
      .then(function (res) {
        refreshCartSections(res.sections);
        document.dispatchEvent(new CustomEvent('zaruba:cart:updated'));
      });
  }

  /* Order note. Written straight to the cart instead of being held in the
     textarea until checkout, because the drawer is re-rendered from the server
     on every add and quantity change and would wipe an unsaved one. The save
     deliberately skips the section refresh — swapping the drawer out
     mid-sentence would take the textarea, and the caret in it, with it. */
  function saveCartNote(value) {
    return fetch(cfg.routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    }).catch(function () {});
  }
  var queueCartNote = debounce(saveCartNote, 500);
  document.addEventListener('input', function (e) {
    if (e.target.closest('[data-cart-note]')) queueCartNote(e.target.value);
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-cart-note]')) saveCartNote(e.target.value);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add-form]');
    if (!form) return;
    e.preventDefault();
    /* A disabled buy button (sold out, or an option combination the product
       doesn't sell) must also stop Enter pressed in the quantity field. */
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.disabled) return;
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-cart-line]');
    if (!wrap) return;
    var key = wrap.getAttribute('data-cart-line');
    var input = wrap.querySelector('[data-cart-qty-input]');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-cart-qty-change'), 10);
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    input.value = next;
    changeLine(key, next);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var wrap = input.closest('[data-cart-line]');
    if (!wrap) return;
    changeLine(wrap.getAttribute('data-cart-line'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute('data-cart-line-remove'), 0);
  });

  /* ---------------------------------------------------------------- */
  /* Hero slider                                                        */
  /* ---------------------------------------------------------------- */
  function initHeroSlider(root) {
    var slides = qsa('[data-hero-index]', root);
    var dots = qsa('[data-hero-dot]', root);
    var count = slides.reduce(function (max, s) { return Math.max(max, parseInt(s.getAttribute('data-hero-index'), 10) + 1); }, 0);
    if (!count) return;
    var idx = 0, timer = null, hovered = false, focused = false;
    /* Paused by the visible pause button, or from the start for anyone who
       has asked their system for reduced motion. */
    var pauseBtn = qs('[data-hero-pause]', root);
    var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      idx = ((i % count) + count) % count;
      slides.forEach(function (s) {
        var on = parseInt(s.getAttribute('data-hero-index'), 10) === idx;
        s.classList.toggle('active', on);
        s.hidden = !on;
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('active', j === idx);
        if (j === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    /* Autoplay holds while the pointer or keyboard focus is in the hero, so a
       slide can't rotate out from under a click on its buy button. */
    function restart() {
      clearInterval(timer);
      timer = hovered || focused || paused ? null : setInterval(function () { show(idx + 1); }, 6500);
    }
    function setPaused(next) {
      paused = next;
      if (pauseBtn) {
        pauseBtn.classList.toggle('is-paused', paused);
        pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
      }
      restart();
    }
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });
    if (count < 2) paused = true;
    setPaused(paused);
    root.addEventListener('mouseenter', function () { hovered = true; restart(); });
    root.addEventListener('mouseleave', function () { hovered = false; restart(); });
    root.addEventListener('focusin', function () { focused = true; restart(); });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      focused = false;
      restart();
    });
    /* Guarded: one throw here aborts the whole IIFE and every feature below it. */
    var heroPrev = qs('[data-hero-prev]', root);
    var heroNext = qs('[data-hero-next]', root);
    if (heroPrev) heroPrev.addEventListener('click', function () { show(idx - 1); restart(); });
    if (heroNext) heroNext.addEventListener('click', function () { show(idx + 1); restart(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); restart(); }); });
    show(0);
    restart();
  }
  qsa('[data-hero-slider]').forEach(initHeroSlider);

  /* ---------------------------------------------------------------- */
  /* Product page: tabs, gallery, variant picker, quantity, sticky bar  */
  /* ---------------------------------------------------------------- */
  /* WAI-ARIA tabs: only the selected tab is in the Tab order; arrow keys,
     Home and End move between tabs and open the one they land on. */
  function initTabs(root) {
    var btns = qsa('[data-tab-btn]', root);
    var panels = qsa('[data-tab-panel]', root);
    function select(btn, moveFocus) {
      var key = btn.getAttribute('data-tab-btn');
      btns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== key; });
      if (moveFocus) btn.focus();
    }
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(btn, false); });
      btn.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = btns[(i + 1) % btns.length];
        else if (e.key === 'ArrowLeft') next = btns[(i - 1 + btns.length) % btns.length];
        else if (e.key === 'Home') next = btns[0];
        else if (e.key === 'End') next = btns[btns.length - 1];
        if (!next) return;
        e.preventDefault();
        select(next, true);
      });
    });
  }

  /* 3D model tab. The viewer is a third-party embed, so its src is set only
     once the panel is on screen — a hidden panel measures 0 wide, which is
     both the cue that the tab was opened and the reason the embed costs
     nothing on the product pages nobody opens it on. */
  function init3DModel(root) {
    var frame = qs('[data-pdp-model]', root);
    if (!frame) return;
    var iframe = qs('iframe', frame);
    var src = frame.getAttribute('data-pdp-model');
    if (!iframe || !src) return;
    function load() {
      iframe.addEventListener('load', function () { frame.classList.add('ready'); });
      iframe.src = src;
    }
    if (!window.ResizeObserver) { load(); return; }
    var ro = new ResizeObserver(function (entries) {
      if (entries[0].contentRect.width > 0) { ro.disconnect(); load(); }
    });
    ro.observe(frame);
  }

  /* Product gallery: arrows, thumbnails, swipe and arrow keys all drive the
     same index. Slides are rendered up front rather than swapped into the DOM,
     so moving between images never shows a half-loaded picture. */
  function initGallery(root) {
    var main = qs('[data-pdp-main-image]', root);
    if (!main) return;
    var slides = qsa('[data-pdp-slide]', main);
    var thumbs = qsa('[data-pdp-thumb]', root);
    var counter = qs('[data-pdp-counter]', main);
    var idx = 0;
    if (slides.length < 2 && thumbs.length < 2) return;

    function show(next) {
      if (!slides.length) return;
      idx = (next % slides.length + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== idx; });
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('active', i === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
    var prevBtn = qs('[data-pdp-prev]', main);
    var nextBtn = qs('[data-pdp-next]', main);
    if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); });

    /* Swipe: horizontal only, so a vertical scroll started on the image still
       scrolls the page. */
    var startX = null;
    var startY = null;
    main.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? idx + 1 : idx - 1);
      startX = null;
      startY = null;
    }, { passive: true });

    /* Only while focus is in the gallery: arrow keys elsewhere on the page
       belong to the tabs, the quantity field and the like. */
    var gallery = main.closest('.pdp-gallery') || main;
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(idx - 1); }
      else if (e.key === 'ArrowRight') { show(idx + 1); }
    });

    show(0);
  }

  function initQtyStepper(root) {
    qsa('[data-qty-stepper]', root).forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-value]');
      var min = parseInt(stepper.getAttribute('data-qty-min') || '1', 10);
      stepper.querySelectorAll('[data-qty-delta]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(min, parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-delta'), 10));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initVariantPicker(root) {
    var form = qs('[data-product-form]', root);
    if (!form) return;
    var variantsEl = qs('[data-product-variants]', root);
    var idInput = form.querySelector('[name="id"]');
    if (!variantsEl || !idInput) return;
    var variantsData;
    try { variantsData = JSON.parse(variantsEl.textContent); } catch (err) { return; }
    if (!Array.isArray(variantsData)) return;
    var priceEl = qs('[data-pdp-price]', root);
    var compareEl = qs('[data-pdp-compare]', root);
    /* Both the main buy button and the sticky bar (which lives outside root). */
    var lineTotalEls = qsa('[data-pdp-line-total]');
    var qtyInput = qs('[data-qty-value]', root);
    var addBtn = qs('[data-pdp-add]', root);
    var skuEl = qs('[data-pdp-sku]', root);
    var stockBadge = qs('[data-pdp-stock-badge]', root);
    /* The sticky bar lives outside root, like the line totals above. */
    var stickyAdd = qs('[data-sticky-add]');
    var stickyVariant = qs('[data-sticky-variant]');

    function selectedOptions() {
      return qsa('[data-option-pill].active', root).reduce(function (acc, el) {
        acc[parseInt(el.getAttribute('data-option-index'), 10)] = el.getAttribute('data-option-value');
        return acc;
      }, []);
    }
    function findVariant(opts) {
      return variantsData.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
    }
    function updateLineTotal() {
      var qty = parseInt((qtyInput || {}).value || '1', 10);
      var v = findVariant(selectedOptions());
      if (!v) return;
      lineTotalEls.forEach(function (el) { el.textContent = formatMoney(v.price * qty); });
    }
    function applyVariant(v) {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.hidden = false; compareEl.textContent = formatMoney(v.compare_at_price);
        } else { compareEl.hidden = true; }
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (addBtn) {
        addBtn.disabled = !v.available;
        var addLabel = addBtn.querySelector('[data-pdp-add-label]');
        if (addLabel) addLabel.textContent = v.available ? t('addToCart') : t('soldOut');
      }
      if (stockBadge) stockBadge.textContent = v.available ? t('inStock') : t('soldOut');
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (stickyVariant) stickyVariant.textContent = v.title;
      root.setAttribute('data-current-variant-price', v.price);
      root.setAttribute('data-current-variant-id', v.id);
      document.dispatchEvent(new CustomEvent('zaruba:variant:changed', { detail: { variant: v } }));
      updateLineTotal();
      /* Real change event (not just .value=) so Shopify's own scripts —
         the dynamic checkout button among them — notice the variant swap too. */
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    qsa('[data-option-pill]', root).forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-option-group]');
        qsa('[data-option-pill]', group).forEach(function (p) {
          p.classList.toggle('active', p === pill);
          p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
        });
        var v = findVariant(selectedOptions());
        if (!v) {
          /* A combination the product doesn't sell (Blue exists, Large exists,
             Blue / Large doesn't): block the buttons rather than leave the last
             real variant's id in the form to be bought by mistake. */
          if (addBtn) {
            addBtn.disabled = true;
            var noneLabel = addBtn.querySelector('[data-pdp-add-label]');
            if (noneLabel) noneLabel.textContent = t('unavailable');
          }
          if (stockBadge) stockBadge.textContent = t('unavailable');
          if (stickyAdd) stickyAdd.disabled = true;
          return;
        }
        applyVariant(v);
        /* Keep ?variant= in the address bar so a copied or shared link — and a
           reload — opens this variant, not the default one. */
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateLineTotal);
    applyVariant(findVariant(selectedOptions()));
  }

  function initStickyBuyBar(root) {
    var bar = qs('[data-sticky-buy-bar]');
    var infoBlock = qs('[data-pdp-info]', root);
    if (!bar || !infoBlock) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { bar.classList.toggle('visible', !entry.isIntersecting); });
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(infoBlock);
  }

  qsa('[data-product-root]').forEach(function (root) {
    initTabs(root);
    init3DModel(root);
    initGallery(root);
    initQtyStepper(root);
    initVariantPicker(root);
    initStickyBuyBar(root);
    initFBT(root);
  });

  /* Frequently-bought-together: checkbox toggles recompute the bundle total
     against the *currently selected* variant's price (kept in sync by
     initVariantPicker via data-current-variant-price / -id on the root). */
  function initFBT(root) {
    var panel = qs('[data-fbt-root]', root);
    if (!panel) return;
    var totalEl = qs('[data-fbt-total]', panel);
    var countEl = qs('[data-fbt-count]', panel);
    var addBtn = qs('[data-fbt-add]', panel);

    function recompute() {
      var mainPrice = parseInt(root.getAttribute('data-current-variant-price') || '0', 10);
      var mainQty = parseInt((qs('[data-qty-value]', root) || {}).value || '1', 10);
      var total = mainPrice * mainQty;
      var count = 1;
      qsa('[data-fbt-toggle]', panel).forEach(function (box) {
        if (box.classList.contains('active')) {
          total += parseInt(box.getAttribute('data-fbt-price'), 10);
          count += 1;
        }
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (countEl) countEl.textContent = count;
    }
    qsa('[data-fbt-toggle]', panel).forEach(function (box) {
      box.addEventListener('click', function () {
        box.setAttribute('aria-pressed', box.classList.toggle('active') ? 'true' : 'false');
        recompute();
      });
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var mainForm = qs('[data-product-form]', root);
        var mainIdInput = mainForm && mainForm.querySelector('[name="id"]');
        if (!mainIdInput) return;
        var mainId = mainIdInput.value;
        var mainQty = parseInt((qs('[data-qty-value]', root) || {}).value || '1', 10);
        var items = [{ id: mainId, quantity: mainQty }];
        qsa('[data-fbt-toggle].active', panel).forEach(function (box) {
          items.push({ id: box.getAttribute('data-fbt-variant-id'), quantity: 1 });
        });
        addBtn.disabled = true;
        addItemsToCart(items, { label: t('bundle') }).finally(function () { addBtn.disabled = false; });
      });
    }
    document.addEventListener('zaruba:variant:changed', recompute);
    if (qs('[data-qty-value]', root)) qs('[data-qty-value]', root).addEventListener('change', recompute);
    recompute();
  }

  /* ---------------------------------------------------------------- */
  /* Compare: tray, header button, modal                               */
  /* ---------------------------------------------------------------- */
  /* One list in localStorage feeds three views — the tray's chips, the count
     on the header button and the table in the modal — so all three re-render
     from renderCompare() whenever the list changes, including when it changes
     in another tab. Card payloads are merchant data going into innerHTML, so
     everything written here goes through escapeHtml first. */
  var COMPARE_KEY = 'zaruba:compare';
  var COMPARE_MAX = 4;
  var COMPARE_ROWS = [t('comparePrice'), t('compareCategory'), t('compareKeySpec'), t('compareRating'), t('compareShips'), t('compareWarranty')];

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function getCompareList() {
    try {
      var list = JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]');
      return Array.isArray(list) ? list.slice(0, COMPARE_MAX) : [];
    } catch (e) { return []; }
  }
  function setCompareList(list) {
    try { localStorage.setItem(COMPARE_KEY, JSON.stringify(list)); } catch (e) {}
    renderCompare();
  }
  function compareCell(item, index) {
    var value = (item.cells || [])[index];
    return value == null || value === '' ? '—' : String(value);
  }
  function compareThumb(item) {
    return item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '';
  }
  function compareModalOpen() {
    var el = qs('[data-drawer="compare-modal"]');
    return !!el && !el.hidden;
  }
  function closeCompareModal() {
    if (compareModalOpen()) closeDrawer('compare-modal');
  }

  function renderCompare() {
    var list = getCompareList();
    var count = list.length;

    qsa('[data-compare-count]').forEach(function (el) { el.textContent = count; });
    qsa('[data-compare-slots]').forEach(function (el) { el.textContent = t('compareSlots', { count: count, max: COMPARE_MAX }); });
    var headerBtn = qs('[data-compare-header]');
    if (headerBtn) headerBtn.hidden = count === 0;

    var bar = qs('#compare-bar');
    if (bar) {
      var chips = qs('[data-compare-chips]', bar);
      if (chips) {
        chips.innerHTML = list.map(function (item) {
          return '<span class="compare-chip">' +
            '<span class="compare-chip__thumb">' + compareThumb(item) + '</span>' +
            '<span class="compare-chip__name">' + escapeHtml(item.title) + '</span>' +
            '<button type="button" class="compare-chip__remove" data-compare-remove="' + escapeHtml(item.id) +
            '" aria-label="' + escapeHtml(t('compareRemoveItem', { title: item.title })) + '">&#10005;</button>' +
            '</span>';
        }).join('');
      }
      var cta = qs('[data-compare-cta]', bar);
      var ctaLabel = qs('[data-compare-cta-label]', bar);
      if (cta) cta.disabled = count < 2;
      if (ctaLabel) ctaLabel.textContent = count < 2 ? t('compareAddOneMore') : t('compareCount', { count: count });
      bar.classList.toggle('visible', count > 0);
      /* The tray and the product page's sticky buy bar are both fixed to the
         bottom. Publish the tray's real height so the buy bar can sit on top
         of it instead of underneath it. */
      document.body.classList.toggle('has-compare-bar', count > 0);
      document.documentElement.style.setProperty('--compare-bar-h', (count > 0 ? bar.offsetHeight : 0) + 'px');
    }

    qsa('[data-compare-toggle]').forEach(function (btn) {
      var on = list.some(function (i) { return String(i.id) === btn.getAttribute('data-compare-toggle'); });
      btn.classList.toggle('active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('title', on ? t('compareRemove') : t('compare'));
    });

    if (compareModalOpen()) renderCompareModal();
  }

  function renderCompareModal() {
    var modal = qs('#compare-modal');
    if (!modal) return;
    var list = getCompareList();
    var hint = qs('[data-compare-hint]', modal);
    var labels = qs('[data-compare-labels]', modal);
    var track = qs('[data-compare-columns]', modal);

    if (hint) hint.hidden = list.length > 1;

    /* A row that reads the same down every column tells you nothing, so it is
       dimmed and the rows that actually differ carry the eye. */
    var same = COMPARE_ROWS.map(function (row, index) {
      if (list.length < 2) return false;
      var first = compareCell(list[0], index);
      return list.every(function (item) { return compareCell(item, index) === first; });
    });

    if (labels) {
      labels.innerHTML = COMPARE_ROWS.map(function (row, index) {
        return '<div class="compare-table__label' + (same[index] ? ' same' : '') + '">' + escapeHtml(row) + '</div>';
      }).join('');
    }
    if (track) {
      track.innerHTML = list.map(function (item) {
        var url = escapeHtml(item.url);
        var title = escapeHtml(item.title);
        var buy = item.variant && item.available !== false
          ? '<button type="button" class="btn btn-accent btn-sm btn-block" data-compare-add="' + escapeHtml(item.variant) +
            '" data-compare-title="' + title + '">' + escapeHtml(t('addToCart')) + '</button>'
          : '';
        return '<div class="compare-col">' +
          '<button type="button" class="compare-col__remove" data-compare-remove="' + escapeHtml(item.id) +
          '" aria-label="' + escapeHtml(t('compareRemoveItem', { title: item.title })) + '">&#10005;</button>' +
          '<a href="' + url + '" class="compare-col__img">' + compareThumb(item) + '</a>' +
          '<a href="' + url + '" class="compare-col__title">' + title + '</a>' +
          COMPARE_ROWS.map(function (row, index) {
            return '<div class="compare-col__cell' + (same[index] ? ' same' : '') + '">' +
              escapeHtml(compareCell(item, index)) + '</div>';
          }).join('') +
          '<div class="compare-col__actions">' + buy +
          '<a href="' + url + '" class="btn btn-outline btn-sm btn-block">' + escapeHtml(t('viewProduct')) + '</a></div>' +
          '</div>';
      }).join('');
    }
    if (list.length === 0) closeCompareModal();
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-compare-toggle]');
    if (toggle) {
      e.preventDefault();
      var id = toggle.getAttribute('data-compare-toggle');
      var list = getCompareList();
      if (list.some(function (i) { return String(i.id) === id; })) {
        setCompareList(list.filter(function (i) { return String(i.id) !== id; }));
        showToast(t('compareRemoved'));
        return;
      }
      if (list.length >= COMPARE_MAX) {
        showToast(t('compareFull', { max: COMPARE_MAX }));
        return;
      }
      var payload;
      try { payload = JSON.parse(toggle.getAttribute('data-compare-payload')); } catch (err) { return; }
      list.push(payload);
      setCompareList(list);
      showToast(list.length < 2
        ? t('compareAddedPickOne')
        : t('compareAdded', { count: list.length, max: COMPARE_MAX }));
      return;
    }

    var remove = e.target.closest('[data-compare-remove]');
    if (remove) {
      e.preventDefault();
      var rid = remove.getAttribute('data-compare-remove');
      setCompareList(getCompareList().filter(function (i) { return String(i.id) !== rid; }));
      return;
    }

    if (e.target.closest('[data-compare-clear]')) {
      e.preventDefault();
      closeCompareModal();
      setCompareList([]);
      return;
    }

    var add = e.target.closest('[data-compare-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      closeCompareModal();
      addItemsToCart([{ id: add.getAttribute('data-compare-add'), quantity: 1 }], { label: add.getAttribute('data-compare-title') })
        .catch(function () {})
        .finally(function () { add.disabled = false; });
      return;
    }

    if (e.target.closest('[data-open-compare-modal]')) {
      e.preventDefault();
      renderCompareModal();
      openDrawer('compare-modal');
    }
  });

  window.addEventListener('storage', function (e) {
    if (e.key === COMPARE_KEY) renderCompare();
  });
  renderCompare();

  /* ---------------------------------------------------------------- */
  /* Predictive search                                                  */
  /* ---------------------------------------------------------------- */
  function initPredictiveSearch() {
    var input = qs('[data-search-input]');
    var resultsWrap = qs('[data-search-results]');
    var labelEl = qs('[data-search-results-label]');
    var seeAll = qs('[data-search-all]');
    if (!input || !resultsWrap) return;

    var run = debounce(function () {
      var q = input.value.trim();
      /* "See all results" follows the query, like pressing Enter does. */
      if (seeAll) seeAll.href = cfg.routes.search + '?' + (q ? 'q=' + encodeURIComponent(q) + '&' : '') + 'type=product';
      if (!q) {
        resultsWrap.innerHTML = resultsWrap.getAttribute('data-default-html') || '';
        if (labelEl) labelEl.textContent = t('searchPopular');
        return;
      }
      if (labelEl) labelEl.textContent = t('searchResultsFor', { terms: q });
      fetch(cfg.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          /* Everything here lands in innerHTML: the query is whatever the
             shopper typed and the rest is merchant copy, so both go through
             escapeHtml or a search for a stray tag would run it. */
          if (!products.length) {
            resultsWrap.innerHTML = '<p class="search-drawer__empty">' + escapeHtml(t('searchNoResults', { terms: q })) + '</p>';
            return;
          }
          resultsWrap.innerHTML = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            return '<a href="' + escapeHtml(p.url) + '" class="result-row">' +
              '<div class="result-thumb">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</div>' +
              '<div class="result-info"><div class="result-title">' + escapeHtml(p.title) + '</div>' +
              '<div class="result-meta">' + escapeHtml(p.type || '') + '</div></div>' +
              '<div class="result-price">' + escapeHtml(p.price) + '</div></a>';
          }).join('');
        })
        .catch(function () {});
    }, 220);
    var clearBtn = qs('[data-search-clear]');
    function syncClear() { if (clearBtn) clearBtn.hidden = input.value.trim() === ''; }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.dispatchEvent(new Event('input'));
        input.focus();
      });
    }
    input.addEventListener('input', function () { syncClear(); run(); });
    syncClear();
    qsa('[data-search-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.getAttribute('data-search-chip');
        input.dispatchEvent(new Event('input'));
        input.focus();
      });
    });
  }
  initPredictiveSearch();
  document.addEventListener('zaruba:drawer:open', function (e) {
    if (e.detail.name === 'search') {
      var input = qs('[data-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 10);
    }
  });

  /* ---------------------------------------------------------------- */
  /* Collection: filters (toggle, price range), sort, load more,        */
  /* and the Read more clamp on the description under the grid          */
  /* ---------------------------------------------------------------- */
  qsa('[data-toggle-filters]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var aside = qs('[data-filters-aside]');
      if (aside) btn.setAttribute('aria-expanded', aside.classList.toggle('open') ? 'true' : 'false');
    });
  });
  qsa('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
  /* Price filter: two handles over one line. They may cross, so the lower
     value always drives the start of the range. Dragging repaints; releasing
     (change) writes the hidden fields Shopify reads and submits. */
  qsa('[data-price-range]').forEach(function (form) {
    var lo = qs('[data-price-thumb-min]', form);
    var hi = qs('[data-price-thumb-max]', form);
    var fill = qs('[data-price-fill]', form);
    var labelLo = qs('[data-price-label-min]', form);
    var labelHi = qs('[data-price-label-max]', form);
    var fieldLo = qs('[data-price-field-min]', form);
    var fieldHi = qs('[data-price-field-max]', form);
    if (!lo || !hi) return;
    var max = parseInt(hi.getAttribute('max'), 10) || 0;

    function paint() {
      var from = Math.min(Number(lo.value), Number(hi.value));
      var to = Math.max(Number(lo.value), Number(hi.value));
      if (fill && max) {
        fill.style.left = (from / max * 100) + '%';
        fill.style.right = (100 - to / max * 100) + '%';
      }
      if (labelLo) labelLo.textContent = formatMoney(from * 100);
      if (labelHi) labelHi.textContent = formatMoney(to * 100);
      if (fieldLo) fieldLo.value = from;
      if (fieldHi) fieldHi.value = to;
    }

    [lo, hi].forEach(function (input) {
      input.addEventListener('input', paint);
      input.addEventListener('change', function () { paint(); form.submit(); });
    });
    paint();
  });

  /* Read more (collection description, review cards): clamp to five lines,
     and only offer the toggle when there is actually something hidden behind
     it. A block that isn't laid out yet — a review card still collapsed behind
     "Show more", or in a closed tab — can't be measured, so it's left whole
     and set up when it's revealed. */
  function setupReadmore(root) {
    if (root.hasAttribute('data-readmore-ready')) return;
    var body = qs('[data-readmore-body]', root);
    var toggle = qs('[data-readmore-toggle]', root);
    if (!body || !toggle || !body.getClientRects().length) return;
    root.setAttribute('data-readmore-ready', '');
    body.classList.add('is-clamped');
    if (body.scrollHeight <= body.clientHeight + 1) {
      body.classList.remove('is-clamped');
      return;
    }
    toggle.hidden = false;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function () {
      var clamped = body.classList.toggle('is-clamped');
      toggle.textContent = clamped ? t('readMore') : t('readLess');
      toggle.setAttribute('aria-expanded', String(!clamped));
    });
  }
  qsa('[data-readmore]').forEach(setupReadmore);

  /* Home reviews: CSS shows one row of cards; the rest are already in the
     page (so crawlers read them) and "Show more reviews" lifts the limit.
     The button goes when nothing is hidden at this width. */
  qsa('[data-reviews]').forEach(function (section) {
    var grid = qs('[data-reviews-grid]', section);
    var more = qs('[data-reviews-more]', section);
    if (!grid || !more) return;
    var hiddenCards = qsa('.review-card', grid).filter(function (card) { return !card.getClientRects().length; });
    if (!hiddenCards.length) {
      more.parentNode.hidden = true;
      return;
    }
    more.addEventListener('click', function () {
      grid.classList.remove('is-collapsed');
      more.setAttribute('aria-expanded', 'true');
      more.parentNode.hidden = true;
      hiddenCards.forEach(setupReadmore);
      // The button just vanished; hand focus to the first card it revealed.
      hiddenCards[0].setAttribute('tabindex', '-1');
      hiddenCards[0].focus({ preventScroll: true });
    });
  });

  /* "Load more" is a real link to the next page (?page=2), so crawlers and
     no-JS visitors can follow it. With JS it appends that page's products in
     place instead, then points itself at the page after. */
  qsa('[data-load-more]').forEach(function (link) {
    var busy = false;
    function reset() {
      busy = false;
      link.removeAttribute('aria-disabled');
      link.textContent = t('loadMore');
    }
    link.addEventListener('click', function (e) {
      var nextUrl = link.getAttribute('href');
      if (!nextUrl) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      link.setAttribute('aria-disabled', 'true');
      link.textContent = t('loading');
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newGrid = tmp.querySelector('[data-product-grid]');
          var curGrid = qs('[data-product-grid]');
          var newLink = tmp.querySelector('[data-load-more]');
          if (newGrid && curGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (child) { curGrid.appendChild(child); });
            renderCompare();
          }
          if (newLink && newLink.getAttribute('href')) {
            link.setAttribute('href', newLink.getAttribute('href'));
            reset();
          } else {
            // Last page: drop the wrapper too, so no empty gap is left behind.
            (link.closest('.zb-more') || link).remove();
          }
        })
        .catch(reset);
    });
  });

  /* Home "Top selling" reveal-more (all products pre-rendered, hidden) */
  qsa('[data-reveal-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = document.querySelector(btn.getAttribute('data-reveal-more'));
      if (!group) return;
      qsa('[data-hidden-row]', group).slice(0, parseInt(btn.getAttribute('data-reveal-count') || '10', 10)).forEach(function (el) {
        el.removeAttribute('data-hidden-row');
        el.hidden = false;
      });
      if (!qs('[data-hidden-row]', group)) (btn.closest('.zb-more') || btn).hidden = true;
    });
  });

  /* ---------------------------------------------------------------- */
  /* Product recommendations (async, Shopify's native endpoint)        */
  /* ---------------------------------------------------------------- */
  qsa('[data-product-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      el.innerHTML = html;
    }).catch(function () {});
  });

  /* A blog post's recommended products row (snippets/article-products.liquid)
     that the post's own links left short: append Shopify's related products
     for its first product, skipping any already in the row. Compared by path,
     since recommended product URLs carry tracking parameters. */
  qsa('[data-article-recommendations]').forEach(function (grid) {
    var url = grid.getAttribute('data-url');
    var missing = parseInt(grid.getAttribute('data-fill'), 10) || 0;
    if (!url || missing < 1) return;
    var shown = qsa('.product-card__media', grid).map(function (a) { return a.pathname; });
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      qsa('.product-card', tmp).forEach(function (card) {
        var link = qs('.product-card__media', card);
        if (missing < 1 || !link || shown.indexOf(link.pathname) !== -1) return;
        shown.push(link.pathname);
        grid.appendChild(card);
        missing--;
      });
    }).catch(function () {});
  });

  /* Discount code: Shopify applies codes via the /discount/<code> route (not a
     /cart POST field), so this navigates there directly. Applied from the cart
     page it comes back to the cart; applied from the drawer it comes back to
     whatever page the shopper was on, with the drawer reopened — see the
     cart=open handler next to openDrawer. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-discount-apply]');
    if (!btn) return;
    var wrap = btn.closest('[data-discount-form]');
    var input = wrap && wrap.querySelector('[data-discount-input]');
    var code = input && input.value.trim();
    if (!code) return;
    var back = cfg.routes.cart || '/cart';
    if (wrap.closest('[data-cart-drawer-root]')) {
      back = window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'cart=open';
    }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });

  /* Account: "Reorder" re-adds a past order's line items to the cart. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reorder]');
    if (!btn) return;
    var items;
    try { items = JSON.parse(btn.getAttribute('data-reorder')); } catch (err) { return; }
    if (!items || !items.length) return;
    btn.disabled = true;
    addItemsToCart(items, { label: t('order') }).finally(function () { btn.disabled = false; });
  });

  /* Sticky mobile buy bar re-submits the real product form. */
  document.addEventListener('click', function (e) {
    var stickyBtn = e.target.closest('[data-sticky-add]');
    if (!stickyBtn || stickyBtn.disabled) return;
    var form = qs('[data-product-form]');
    if (form && form.requestSubmit) form.requestSubmit();
    else if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
  });

  /* ---------------------------------------------------------------- */
  /* Cart page free-shipping bar + qty on cart page reuse same handlers */
  /* ---------------------------------------------------------------- */
})();
